<div >
  <div>
    <!-- Optinal sightseeing section -->
    <div class="ion-no-padding my-1">
      <div class="ion-padding-horizontal py-1 bg-light-gray d-flex justify-content-between">
        <ion-title class="dark-title-sm ion-no-padding">Optional Sigthseeing</ion-title>
        <div>
          <div class="currency-container position-relative">
            <ion-toggle [enableOnOffLabels]="true" class="section-toggle align-middle" [(ngModel)]="formEnabled" (ngModelChange)="formToggleChanged()"></ion-toggle>
            <p class="toggle-tooltip" [ngClass]="formEnabled ? 'green': 'red'">{{formEnabled ? 'This section will be displayed in the package.' : 'This section will not be displayed in the package.'}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="ion-padding-horizontal" *ngIf="formEnabled">
      <form [formGroup]="sightSeeingForm">
        <div>
          <table class="pricing-table">
            <thead>
              <tr>
                <th style="width: 200px;">Location</th>
                <th>Visiting Places*</th>
                <th style="width: 120px;">Cost*</th>
                <th style="width: 50px;"></th>
              </tr>
            </thead>
            <tbody formArrayName="locations">
              <ng-container *ngFor="let location of getLocationsArray().controls; index as locationIndex" [formGroupName]="locationIndex">
                <tr>
                  <td [rowSpan]="getVisitingPlacesArray(locationIndex).length + 1">
                    <div class="location-item">
                      <div class="location">
                        <div class="input-container mb-0">
                          <div [ngClass]="{ 'invalid-input': location.get('locationName')?.invalid && location.get('locationName')?.touched }">
                            <select class="input" formControlName="locationName">
                              <option value="" hidden>Select Location</option>
                              <option *ngFor="let location of getAvailableLocations(locationIndex)" [value]="location">{{location}}</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
                <ng-container formArrayName="visitingPlaces">
                  <tr *ngFor="let visitingPlace of getVisitingPlacesArray(locationIndex).controls; index as placeIndex" [formGroupName]="placeIndex">
                    <td>
                      <div [ngClass]="{ 'invalid-input': visitingPlace.get('place')?.invalid && visitingPlace.get('place')?.touched }">
                        <input class="input" style="text-align: left !important;" placeholder="Type Here" formControlName="place">
                      </div>
                    </td>
                    <td>
                      <div [ngClass]="{ 'invalid-input': visitingPlace.get('cost')?.invalid && visitingPlace.get('cost')?.touched }">
                        <input appNumbersOnly class="input" placeholder="0" formControlName="cost">
                      </div>
                    </td>
                    <td>
                      <div class="">
                        <ion-button fill="clear" color="danger" class="table-action-btn" (click)="removeVisitingPlaces(locationIndex, placeIndex)" [disabled]="getVisitingPlacesArray(locationIndex).length <= 1">
                          <ion-icon slot="icon-only" name="trash-outline"></ion-icon>
                        </ion-button>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td colspan="4">
                      <div class="d-flex justify-content-between">
                        <div>
                          <ion-button class="sm-clear-btn" fill="clear" size="small" (click)="addLocation()" *ngIf="getLocationsArray().length < destinationsArray.length && getLocationsArray().length-1 == locationIndex">
                            <ion-icon name="add-outline"></ion-icon> Add Location
                          </ion-button>
                          <ion-button class="sm-clear-btn" fill="clear" size="small" color="danger" (click)="removeLocation(locationIndex)" *ngIf="getLocationsArray().length > 1">
                            <ion-icon name="close-outline"></ion-icon> Remove Location
                          </ion-button>
                        </div>
                        <div>
                          <ion-button class="sm-clear-btn" fill="clear" size="small" (click)="addVisitingPlaces(locationIndex)">
                            <ion-icon name="add-outline"></ion-icon> Add Pax
                          </ion-button>
                          <ion-button class="sm-clear-btn" fill="clear" size="small" color="danger" (click)="removeAllVisitingPlaces(locationIndex)">
                            <ion-icon name="close-outline"></ion-icon> Clear Pax
                          </ion-button>
                        </div>
                      </div>
                    </td>
                  </tr>
                </ng-container>
              </ng-container>
            </tbody>
          </table>
        </div>
      </form>
    </div>
  </div>
</div>
